<server-selection (serverSelected)="selectProject($event)"></server-selection>
